var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/email-signup/email-signup-confirmation-form.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
env.getTemplate("macros/form-validation.j2", false, "core/templates/modal/user/email-signup/email-signup-confirmation-form.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_4 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_4);
if(t_1.hasOwnProperty("hasErrors")) {
var t_5 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_5);
if(t_1.hasOwnProperty("validatedField")) {
var t_6 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_6);
if(t_1.hasOwnProperty("nonRequiredValidatedField")) {
var t_7 = t_1.nonRequiredValidatedField;
} else {
cb(new Error("cannot import 'nonRequiredValidatedField'")); return;
}
context.setVariable("nonRequiredValidatedField", t_7);
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_8 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_8);
output += "\n\n<form novalidate class=\"js-email-signup-personalize-form\" method=\"post\" action=\"\" enctype=\"application/x-www-form-urlencoded\" data-qa-signup-personalize-form>\n\n    <div class=\"c-email-signup\">\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <h2 class=\"c-email-signup__h2\" data-qa-email-confirmation-header>\n                    ";
output += runtime.suppressValue((lineno = 13, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-confirmation-header"])), env.opts.autoescape);
output += "\n                </h2>\n\n                <p class=\"c-email-signup__p\" data-qa-email-confirmation-copy>\n                    ";
output += runtime.suppressValue((lineno = 17, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-confirmation-copy"])), env.opts.autoescape);
output += "\n                </p>\n\n                <h3 class=\"c-email-signup__h3\" data-qa-email-personalize-header>\n                    ";
output += runtime.suppressValue((lineno = 21, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-confirmation-personalize-header"])), env.opts.autoescape);
output += "\n                </h3>\n\n            </div>\n\n        </div>\n\n        ";
if((lineno = 28, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.modal.emailSignup.messages.generalErrors",false]))) {
output += "\n            <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12\">\n                    ";
output += runtime.suppressValue((lineno = 32, colno = 41, runtime.callWrap(t_8, "displayGeneralErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"messages")),"generalErrors"),runtime.makeKeywordArgs({"class": "c-form-block"})])), env.opts.autoescape);
output += "\n                </div>\n\n            </div>\n        ";
;
}
output += "\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12\">\n\n                <div class=\"c-email-signup__form c-form__field\">\n\n                    <label for=\"firstName\" class=\"c-form__label\">\n                        ";
output += runtime.suppressValue((lineno = 45, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-confirmation-first-name"])), env.opts.autoescape);
output += "\n                    </label>\n\n                    <input type=\"text\" name=\"firstName\" class=\"c-form__text js-email-signup-input\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"firstName"), env.opts.autoescape);
output += "\" data-qa-email-confirmation-first-name/>\n\n                </div>\n\n                <div class=\"c-email-signup__form c-form__field\">\n\n                    <label for=\"lastName\" class=\"c-form__label\">\n                        ";
output += runtime.suppressValue((lineno = 55, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-confirmation-last-name"])), env.opts.autoescape);
output += "\n                    </label>\n\n                    <input type=\"text\" name=\"lastName\" class=\"c-form__text js-email-signup-input\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"lastName"), env.opts.autoescape);
output += "\" data-qa-email-confirmation-last-name/>\n\n                </div>\n\n                <div class=\"c-email-signup__form c-form__field\">\n\n                    <label for=\"country\" class=\"c-form__label\">\n                        ";
output += runtime.suppressValue((lineno = 65, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-confirmation-country"])), env.opts.autoescape);
output += "\n                    </label>\n\n                ";
frame = frame.push();
var t_11 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteConfig")),"sites");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("site", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
if(runtime.memberLookup((t_12),"siteId") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteId")) {
output += "<select id=\"email-signup-country\" name=\"country\" data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" name=\"email-signup-country\" class=\"c-form__select js-email-signup-input js-country-select\" data-qa-email-confirmation-country>\n                            <option value=\"\" disabled selected hidden>\n                                ";
output += runtime.suppressValue((lineno = 72, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email-signup_select-option"])), env.opts.autoescape);
output += ":\n                            </option>\n                                ";
frame = frame.push();
var t_15 = runtime.memberLookup((t_12),"countries");
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("country", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\n                                    <option data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_16),"countryCode"), env.opts.autoescape);
output += "\" >\n                                        ";
output += runtime.suppressValue(runtime.memberLookup((t_16),"name"), env.opts.autoescape);
output += "\n                                    </option>\n                                ";
;
}
}
frame = frame.pop();
output += "</select>\n                    ";
;
}
;
}
}
frame = frame.pop();
output += "</div>\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-small--8\">\n\n                <div class=\"c-email-signup__form c-form__field ";
output += runtime.suppressValue((lineno = 93, colno = 73, runtime.callWrap(t_5, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"messages")),"postalCode")])), env.opts.autoescape);
output += "\">\n\n                    <label for=\"postalCode\" class=\"c-form__label\">\n                        ";
output += runtime.suppressValue((lineno = 96, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-confirmation-zip"])), env.opts.autoescape);
output += "\n                    </label>\n\n                    <input ";
output += runtime.suppressValue((lineno = 99, colno = 53, runtime.callWrap(t_7, "nonRequiredValidatedField", context, ["INVALID_ZIP_CODE","address","postalCode"])), env.opts.autoescape);
output += " type=\"text\" name=\"postalCode\" class=\"c-form__text js-email-signup-input\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"postalCode"), env.opts.autoescape);
output += "\" data-qa-email-confirmation-zip-code/>\n                    ";
output += runtime.suppressValue((lineno = 100, colno = 39, runtime.callWrap(t_4, "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"emailSignup")),"messages")),"postalCode")])), env.opts.autoescape);
output += "\n\n                </div>\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12 o-small--8\">\n\n                    <button type=\"submit\" class=\"c-button-primary js-email-personalize-signup\" data-email-signup-source=\"Site Footer\" data-qa-email-confirmation-submit>\n                        ";
output += runtime.suppressValue((lineno = 113, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-confirmation-submit-button"])), env.opts.autoescape);
output += "\n                    </button>\n\n                </div>\n\n                <div class=\"o-column o-extra-small--12 o-small--4 c-email-signup__cancel\">\n\n                    <a href=\"\" class=\"u-link--underlined c-email-signup__a js-modal__close\" data-qa-confirm-email-cancel>\n                        ";
output += runtime.suppressValue((lineno = 121, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-confirmation-cancel"])), env.opts.autoescape);
output += "\n                    </a>\n\n                </div>\n\n        </div>\n\n    </div>\n\n</form>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/email-signup/email-signup-confirmation-form.j2"] , dependencies)